import useTitanApp from "../../hooks/useTitanApp";
import { useState, useEffect } from "react";
import {
  getServiceDetails,
  getMemberDetails,
  fetchReportById,
} from "@/dispatchers/analyticsDispatchers";

export const useAnalyticsData = () => {
  const { analyticsState, appState } = useTitanApp();
  const {
    revenueTrend,
    averageCompliance,
    servicesPerformance,
    bookingsGrowth,
    isAnalyticsLoading,
    memberPerformance,
    membersCompliance,
    performanceDistribution,
    allAnalyticsReports,
    selectedReportData,
    serviceDetails,
    isServiceDetailsLoading,
    memberDetails,
    isMemberDetailsLoading,
  } = analyticsState;
  const { companyId, currentPharmacyId, currentCompanyId } = appState;
  interface ServiceConsultation {
    id: string;
    patientName: string;
    practitioner: string;
    date: string;
    time: string;
    duration: number;
    compliance: number;
  }
  const [totalRevenue, setTotalRevenue] = useState<number>(0);
  const [serviceAvg, setserviceAvg] = useState<number>(0);
  const [totalMemberRevenue, setTotalMemberRevenue] = useState<number>(0);
  const [memberSpecificAvgDuration, setmemberSpecificAvgDuration] = useState<number>(0.00);

  const handleSetSelectedService = async (
    serviceName: string
    ,startDate: string, endDate : string
  ): Promise<ServiceConsultation[]> => {
    const id = servicesPerformance.find(
      (x) => x.name === serviceName,
    )?.serviceId;
    const payload = {
      companyId: companyId,
      serviceId: id,
      startDate: startDate,
      endDate: endDate,
    };

    const result = await getServiceDetails(payload);
    setTotalRevenue(result?.totalRevenue);
    setserviceAvg(result?.avgDuration);
    return result?.serviceAnalytics;
  };

  const handleSetSelectedMember = async (memberEmail: string,startDate: string, endDate : string) => {
    const payload = {
      companyId: companyId,
      memberEmail: memberEmail,
      startDate: startDate,
      endDate: endDate,
    };
    const result = await getMemberDetails(payload);
    setTotalMemberRevenue(result?.totalRevenue);
    setmemberSpecificAvgDuration(result?.avgDuration || 0.00);
    return result?.memberAnalytics || [];
  };

  const handleSelectReport = async (reportTypeId: string,startDate: string, endDate : string) => {
    const payload = {
      reportID: reportTypeId,
      startDate: startDate,
      endDate: endDate,
      companyID: companyId,
      pharmacyID: currentPharmacyId,
    };
    const result = await fetchReportById(payload);
    return result;
  };



  return {
    // data
    revenueTrend,
    averageCompliance,
    servicesPerformance,
    isAnalyticsLoading,
    bookingsGrowth,
    memberPerformance,
    membersCompliance,
    performanceDistribution,
    allAnalyticsReports,
    selectedReportData,
    companyId,
    currentPharmacyId,
    serviceDetails,
    handleSetSelectedService,
    isServiceDetailsLoading,
    totalRevenue,
    currentCompanyId,
    handleSetSelectedMember,
    isMemberDetailsLoading,
    totalMemberRevenue,
    handleSelectReport,
    memberSpecificAvgDuration,
    serviceAvg
  };
};
